const dictionaryNL = {
  originalWriting: 'Nederland',
  general: {
    user: 'Gebruiker',
    email: 'E-mail',
    password: 'Wachtwoord',
    close: 'Sluiten',
    save: 'Opslaan',
    done: 'Klaar',
    accept: 'Aanvaarden ',
    cancel: 'Annuleren',
    decline: 'Afwijzen',
    cut: 'Knip',
    browse: 'Browser',
    chooseFileLabel: 'Kies bestand...',
    selectedCountLabel: 'Bestanden geselecteerd',
    from: 'Van',
    perDay: 'per dag',
    select: 'Selecteer',
    owner: 'Eigenaar',
    details: 'Details',
    sizeList:[
      'Geen',
      'Klein',
      'Middel',
      'Groot',
    ],
    options: 'Opties',
    status: 'Status',
    pay: 'Betalen',
    edit: 'Bewerking',
    from: 'Van',
    to: 'Naar',
    date: 'Datum',
    place: 'Plaats',
    empty: 'Leeg',
    full: 'Vol',
    go: 'Gaan',
    uploadImagesLabel: 'Afbeeldingen uploaden (Max %%)',
    uploadListLimitMessage: 'U moet %% afbeeldingen selecteren om te uploaden',
    back: 'Terug',
    car: 'Auto',
    decide: 'Beslissing',
    clear: 'Vrijmaken',
    document: 'Document',
  },
  user: {
    login: {
      title: 'Inloggen',
      userMailLabel: 'Gebruiker of e-mail',
      userMailPlaceHolder: 'Gebruikersnaam of email',
      userPasswordLabel: 'Wachtwoord',
      userPasswordPlaceholder: 'Wachtwoord',
      loginButtonLabel: 'Inloggen',
      newUserLabel: 'Nieuw Account',
      successfulLabel: 'U bent momenteel ingelogd'
    },
    reset: {
      titleDialog: 'Wachtwoord vergeten herstellen',
      requestNewPassword: 'Wachtwoordherstel',
      generateNewPassword: 'Nieuw wachtwoord genereren',
      getKey: 'Ik krijg een code',
      userResetTokenLabel: 'Tokensleutel resetten',
      userResetTokenPlaceholder: 'Tokensleutel resetten',
      requestNewPasswordLabel: 'Nieuw verzoek',
      changePasswordLabel: 'Wachtwoord wijzigen',
      requestPasswordMessage: "Als het ingevoerde e-mailadres in onze database is geregistreerd, is er een code naar de inbox verzonden",
      executePasswordMessage: 'Het wachtwoord van de gebruiker is gewijzigd, u kunt nu inloggen',
    },
    newAccount: {
      titleDialog: 'Registreer een nieuwe gebruiker',
      titleForm: 'Nieuwe gebruiker',
      userNameLabel: 'Gebruikersnaam',
      userNamePlaceHolder: 'Gebruikersnaam (minimaal 8 tekens)',
      userEmailLabel: 'E-mail',
      userEmailPlaceholder: 'E-mail',
      userPasswordLabel: 'Wachtwoord',
      userPasswordAllowedCharsMessage: 'Toegestane tekens: hoofdletters, kleine letters, cijfers en @$!%*?&',
      userPasswordPlaceholder: 'Wachtwoord (minimaal 8 tekens)',
      userPasswordConfirmLabel: 'Wachtwoord bevestigen',
      userPasswordConfirmPlaceHolder: 'Wachtwoord bevestigen',
      userAgreementCheckbox: 'Ik accepteer de overeenkomst volledig',
      userAgreementViewDoc: 'Bekijk overeenkomst',
      userMissingFieldsMessage: 'Sommige velden ontbreken, vul de verplichte velden in.',
      userMinLengthMessage: 'De gebruikersnaam moet minimaal 8 tekens lang zijn.',
      userEmailValidMessage: 'Gelieve een geldig e-mailadres in te vullen.',
      userPasswordValidationsMessage: 'Wachtwoord is niet sterk genoeg. Moet minimaal 8 tekens bevatten <br/> Moet minimaal 1 kleine letter bevatten.<br/>Moet minimaal 1 hoofdletter bevatten<br/>Moet één cijfer bevatten.<br/>Het moet ten minste één van deze tekens bevatten: @$!%*?&',
      userPasswordMismatchMessage: 'Wachtwoord komt niet overeen.',
      userAcceptAgreementMessage: 'U moet accepteren dat u onze overeenkomstvoorwaarden heeft gelezen en geaccepteerd.',
      userSuccesfullyCreatedMessage: 'Gebruiker is aangemaakt. Open alstublieft uw e-mailaccount en schakel deze in.',
    },
    edit: {
      title: 'Gebruikersaccounteditie',
      tabs: [
        'Gebruikers account',
        'Persoonlijk',
        'Locatie',
        'Auto gegevens',
      ],
      account: {
        avatarSelection: 'Avatar editie/selectie',
        avatarUploadImage: 'Afbeelding uploaden',
        avatarSave: 'Opslaan',
        uploadAvatarOkMessage: 'Avatar afbeelding succesvol bijgewerkt',
        instructionsLabel: 'Instructies',
        instructionsStepOne: 'Selecteer een bestand om te uploaden',
        instructionsStepTwo: 'Pas de afbeelding in de sectie naar wens aan: verplaatsen, centreren, zoomen, enz',
        instructionsStepThree: 'Druk op de knop [Knippen] in de geselecteerde sectie, dit wordt je avatarafbeelding',
        instructionsStepFour: 'Druk op [Opslaan] om je huidige avatarafbeelding toe te voegen of bij te werken',
      },
      personal: {
        title: 'Persoonlijke gegevens',
        contactFullName: 'Volledige naam',
        contactFirstName: 'Voornaam',
        contactLastName: 'Achternaam',
        contactGenderLabel: 'Geslacht',
        contactGenderMale: 'Man',
        contactGenderFemale: 'Vrouw',
        contactGenderX: 'X',
        contactBirthDateLabel: 'Geboorte datum',
        contactNotAdultMessage: 'De leeftijd van de bestuurder is niet die van een wettelijke volwassene',
        contactSave: 'Informatie opslaan',
        viewLicense: 'Rijbewijs bekijken',
        licenseSave: 'Rijbewijs opslaan',
        uploadLicenseLabel: 'Upload uw rijbewijs (voor-en achterkant) (Max 2)',
        updateContactOkMessage: 'Contactgegevens bijgewerkt',
        uploadLicenseRequiredLengthFilesMessage: 'Selecteer voor- en achterkantafbeeldingen voor uw rijbewijs',
        uploadLicenseFileOkMessage: 'Rijbewijs bijgewerkt',
      },
      location: {
        title: 'Adres',
        addressLabel: 'Volledig adres',
        streetLabel: 'Straat',
        streetPlaceHolder: 'Straat naam',
        externalNumber: 'Extern nummer',
        externalNumberPlaceHolder: 'Adres extern nummer',
        district: 'Wijk',
        districtPlaceHolder: 'Wijk',
        zipCode: 'Postcode',
        zipCodePlaceHolder: 'Postcode',
        phone: 'Telefoonnummer',
        phonePlaceHolder: 'Voeg uw telefoonnummer toe',
        email: 'E-mail',
        emailPlaceHolder: 'Voeg uw e-mailadres toe',
        province: 'Province',
        locality: 'Land',
        localityPlaceHolder: 'Land',
        addressSave: 'Adres opslaan',
        updatedContactAdressMessage: 'Contactadresgegevens bijgewerkt',
        currenteOwnerLocationLabel: 'Eigenaar bevindt zich ongeveer op',
      },
    },
  },
  home: {
    title: 'Home',
    panelLeft: {
      userLabel: 'Gebruiker',
      userNewAccountLabel: 'Nieuw account',
      userResetPasswordLabel: 'Wachtwoord opnieuw instellen',
      userEditAccountLabel: 'Bewerk account',
      item: 'Leningen (testen)',
    },
    panelRight: {
      userLabel: 'Gebruiker',
      userRegister: 'Registreer',
      sessionLabel: 'Sessie',
      sessionLogInLabel: 'Inloggen',
      sessionLogOutLabel: 'Uitloggen',
      lightThemeLabel: 'Licht thema',
      selectLanguageLabel: 'Taal',
      sessionLogOutMessage: 'Je bent uitgelogd.',
      allowWebNotifications: 'Notificaties (web)',
      notAllowedWebNotificationsMessage: 'Als je meldingen niet toestaat, kun je geen berichten ontvangen wanneer je een aanvraag voor je auto krijgt of wanneer iemand erom vraagt.',
    },
    topMenu: {
      offer: 'Aanbod',
      lend: 'Lener',
      howItWorks: 'Hoe werkt het?',
      contact: 'Contact',
      notifications: 'Notificaties',
    },
    main: {
      borrowCarLabel: 'Leen een Auto',
      sloganLabel: 'Samen maken we de wereld duurzamer.',
      whatCarsLabel: "Welke auto's zijn beschikbaar?",
      location: 'Locatie',
      date: 'Datum',
      viewAvailabilityLabel: 'Beschikbaarheid bekijken',
      flexible: 'Flexibel',
      durable: 'Duurzaam',
      transparent: 'Transparant',
      loanOfferLabel: 'Leen aanbod',
      enterLocationToSearch: 'Voer een locatie in om te zoeken',
      currentSelectedPlaces: 'Huidige geselecteerde plaatsen',
    },
  },
  car: {
    dashboard: {
      title: 'Dashboard',
      carList: 'Auto lijst',
      additionalData: 'Extra gegevens',
      aboutLender: 'Over de uitlener'
    },
    features: {
      titleShort: 'Kenmerken',
      titleDialog: 'Selecteer Autokenmerken',
      isUsed: 'Gebruikt?',
      name: 'Naam',
      value: 'Waarde',
    },
    restrictions: {
      titleShort: 'Beperkingen',
      titleDialog: 'Selecteer autobeperkingen',
    },
    penalties: {
      titleShort: 'Straffen',
      titleDialog: 'Straffen voor misbruik',
    },
    edit: {
      title: 'Autodata-editie',
      useMyCarLabel: 'Ik wil mijn auto uitlenen',
      manufacturerLabel: 'Automerk',
      modelLabel: 'Model',
      yearLabel: 'Bouwjaar',
      priceLabel: 'Prijs',
      descriptionLabel: 'Omschrijving',
      carSave: 'Auto-info opslaan',
      carImageUploadLabel: 'Auto afbeelding',
      carImageUploadSave: 'Upload auto-afbeelding',
      carPlateUploadLabel: 'Kenteken afbeelding',
      carPlateUploadSave: 'Upload kenteken',
      carFeatureLabel: 'Auto-eigenschappen',
      carUseRestrictionLabel: 'Beperkingen voor autogebruik',
      carImagesPhotoBrowserLabel: 'Toon auto-afbeeldingen',
      carImageFileListLabel: 'Upload afbeeldingenlijst',
      uploadCarImagesLabel: 'Upload afbeeldingen van uw auto (Max 6)',
      updatedCarMessage: 'Autogegevens succesvol bijgewerkt',
      selectFileToUpload: 'Selecteer een bestand om te uploaden',
      carImageUploadedOkMessage: 'Autoafbeelding succesvol geüpload',
      carPlateUploadedOkMessage:'Autoafbeelding succesvol geüpload',
      uploadCarImagesLimitMessage: 'U moet 6 afbeeldingen voor uw auto selecteren',
      carImageListUploadedOkMessage: 'Lijst met auto-images succesvol geüpload',
      carIsUsedStatusMessage: 'De auto is momenteel uitgeleend en kan nu niet worden bijgewerkt',
      carSize: 'Autogrootte',
      carEstimatedPrice: 'Geschatte prijs auto',
      suggestedLoanPrice: 'Voorgestelde leenprijs',
      carMinPrice: 'Auto Minimum Prijs',
      carMaxPrice: 'Maximale prijs auto',
      minRecommendedPrice: 'Minimale adviesprijs',
      maxRecommendedPrice: 'Maximale aanbevolen prijs',
      checkSizeMessage: 'Selecteer een autogrootte om de voorgestelde prijs te bepalen',
      recommendedPriceMessage: 'Stel de dagprijs voor uw [%%] auto in tussen [€%%] en [€%%] om deze aantrekkelijk te houden voor huurders',
      licensePlate: "Kentekenplaat",
      selectRestrictedDateLabel: 'Selecteer beperkte data',
      selectRestrictedDatePlaceholder: 'Selecteer beperkte data',
      saveRestrictedDates: 'Data opslaan',
      selectRestrictedDates: 'Selecteer data',
      deleteAllRestrictedDates: 'Verwijder alle datums',
      errorRestrictedDate: 'Selecteer enkele data om de uitleentermijn van uw auto te beperken',
      messageRestrictedDate: 'Beperkte data opgeslagen voor deze auto',
      confirmDeleteRestrictedDate:'Wilt u alle huidige beperkte data voor uw auto verwijderen?',
      messageDeletedRestrictedDate:'Alle beperkte data voor deze auto zijn verwijderd',
      carPreferredDeliveryTime: 'Gewenste levertijd',
      carPreferredReturnTime: 'Gewenste retourtijd',
      penaltiesForMisusing: 'Straffen voor misbruik',
    },
  },
  loan: {
    title: 'Leen',
    lends: 'Uitleners',
    borrows: 'Leners',
    tabs: [
      'Aanvraag',
      'Beslissen',
      'Betaling',
      //'Verzekering',
      'Afspraak',
      'Ontmoeting',
      'Stoppen',
      'Terugkerend',
      'Beoordeling',
      'Issues',
    ],
    dashboard: {
      carLoanTag: 'Label',
      lender: 'Uitlener',
      borrower: 'Lener',
      startDate: 'Startdatum',
      endDate: 'Einddatum',
      daysToBorrow: 'Dagen te leen',
      totalToPay: 'Totaal te Betalen',
      discounts: 'Kortingen',
      isGoingAbroad: 'Gaat Naar het Buitenland',
      returningKilometers: "Terugkomende km's",
      currentKilometers: "Huidige km's",
      pricePerDay: 'Prijs per Dag',
    },
    request: {
      loanPeriod: 'Leen periode',
      loanRangeDatePlaceHolder: 'Selecteer een datumbereik',
      onlyDriver: 'Slechts één bestuurder',
      driveAbroad: 'Ga je naar het buitenland rijden? (+€ 1 per dag)',
      extraDriverData: 'Extra chauffeursgegevens',
      messageRangeDate: 'Selecteer een reeks data waarop u reist',
      onEmptyFormField: 'Vul alstublieft de gegevens van de extra bestuurder in, veld: %%',
      confirmSaveRequest: 'Voeg uw wachtwoord toe om te bevestigen dat u akkoord gaat met het vragen naar deze auto',
      messageSavedRequest: 'De uitlener moet uw verzoek accepteren',
      onLoanPeriodAtLeast3Days: 'De leenperiode moet minimaal 3 dagen vanaf vandaag zijn ingesteld',
      onLoadPeriodGreater30Days: 'De leenperiode mag niet langer zijn dan 30 dagen',
      loanPeriodStartTime: 'Selecteer de starttijd van de lening',
      loanPeriodEndTime: 'Selecteer eindtijd van de lening',
      buyoutDeposit: 'Aanbetaling voor afkoop',
      buyoutDepositOption: 'Selecteer een afkoopsomoptie',
      messageOngoingDates:'Deze auto heeft een aantal gereserveerde data om te gebruiken, kies een aantal ongebruikte data',
      messageRestrictedDates:'Voor deze auto gelden een aantal beperkte gebruiksdata. Kies een aantal ongebruikte data.',
      aboutCarOwner: 'Over de eigenaar',
      userRatingLabel: 'Gebruikersbeoordeling',
      invoice: {
        title: 'Totaal betaald',
        details: 'Factuurgegevens',
        basePrice: 'Prijs €%% in %% dagen',
        depositFee: 'Uitkoopsom aanbetalingskosten',
        depositToPay: 'Aanbetaling om te betalen',
        daysToBorrow: 'Dagen om te lenen',
        weeksToBorrow: 'Weken om te lenen',
        discountPercent: 'Korting %%%',
        totalDiscount: 'Totale korting',
        daysToGoAbroad: 'Dagen om naar het buitenland te gaan',
        weekendSurcharge: 'Weekendtoeslag %%%',
        holidaySurcharge: 'Vakantietoeslag',
        serviceFee: 'Servicekosten',
        administrativeFee: 'Administratiekosten',
        underAgeRate: 'Onderleeftijdstarief',
        subtotal: 'Subtotaal',
        taxes: 'Belastingen',
        totalToPay: 'Totaal te betalen',
      },
    },
    deciding: {
      confirmCancel: 'Wilt u ANNULEREN om deze auto uit te lenen?',
      messageCancel: 'Lener heeft geweigerd de auto te lenen. Bewerkingen annuleren ...',
      confirmAccept: 'Wilt u uw auto uitlenen?',
      messageAccept: 'Voor een verzekering moet u een aanbetaling doen',
      hasDecided: 'heeft besloten om uw auto te vragen',
      loanInfo: 'Lening info',
      yourEarnings: 'Uw inkomsten',
    },
    payment: {
      title: 'Uw lening is bijna klaar, ga verder met betalen om door te gaan',
      goPay: 'Ga verder met betalen',
      popupTitle: 'Uw betaling',
      messageStripePaymentStatus: 'Uw betaling was %%',
      confirmCancel: 'Wilt u de betaling voor de aangevraagde auto ANNULEREN?',
      messageCancel: 'Lener heeft besloten niet te betalen voor de auto. Bezig met annuleren van operaties ...',
      messageAfterSucceded: 'De lener is nu op de hoogte gebracht om de verzekering voor te bereiden. U kunt een afspraak verwachten om verder te gaan',
    },
    appointment: {
      labelData: 'Afspraakgegevens',
      pleaseNote: 'Let op dat',
      notRenting: 'De LeenAuto is geen verhuurdienst, maar een leen- en uitleendienst. Het is daarom aan te raden een externe verzekering af te sluiten voor de veiligheid',
      noLawIssues: 'Bovendien is de lener zorgvuldig gecontroleerd om te garanderen dat hij/zij geen contact heeft gehad met het gerechtelijk systeem en/of dit heeft aangegeven. De lener heeft ook verklaard in overeenstemming te zijn met de Algemene Voorwaarden van DeLeenAuto',
      agreedOnRequirements: 'Ten slotte komen de verklaring, vereisten en alle voorwaarden van de externe verzekering overeen met de Algemene Voorwaarden van DeLeenAuto.',
      insuranceFrom: ' De LeenAuto beveelt aan om dit te doen via',
      insuranceHasBeenAdded: 'Ik heb een verzekering aan mijn auto toegevoegd',
      selectAppointmentDate: 'Selecteer een datum voor de ontmoeting met uw lener',
      selectAppointmentPlace: 'Selecteer een plaats voor de ontmoeting met uw lener',
      confirmAddedInsurance: 'Bevestig dat u een verzekering hebt toegevoegd',
      noAppointmentSelected :'Geen afspraakdatum geselecteerd',
      noPlaceEntered: 'Geen plaats ingevoerd',
      confirmMeeting:'Wilt u uw lener ontmoeten op %% om %%?',
      messageMeeting: 'De lener wordt op de hoogte gebracht om u te ontmoeten op %% om %%',
    },
    meeting: {
      uploadCarLoanImagesLabel: "Upload de huidige foto's van de auto (maximaal 8)",
      uploadDriverImagesLabel: 'Upload rijbewijzen (eigenaar, lener + extra) (maximaal 7)',
      currentFuelLevel: 'Huidig brandstofniveau',
      currentKilometers: 'Huidige kilometers',
      imageListLimitMessage: 'U moet %% afbeeldingen selecteren om te uploaden',
      confirmStartLoan: 'Wilt u de lening starten?',
      confirmEndLoan: 'Wilt u de lening beëindigen?',
      showCarImageLabel: 'Toon afbeeldingen van de auto',
      showDriverImageLabel: 'Toon afbeeldingen van de bestuurders',
      emptyTank: 'De brandstoftank mag niet leeg zijn',
      kilometersBelowOne: 'Kilometers kunnen niet minder zijn dan nul',
    },
    backAppointment: {
      selectAppointmentDate: 'Selecteer een datum voor een ontmoeting met uw uitlener',
      selectAppointmentPlace: 'Selecteer een locatie voor een ontmoeting met uw uitlener',
      confirmMeeting:'Wilt u uw uitlener ontmoeten in %% op %%?',
      messageMeeting: 'De uitlener zal op de hoogte worden gebracht om u te ontmoeten in %% op %%',
    },
    issue: {
      checkLabel: 'Heb je een probleem gehad?',
      description: 'Beschrijf uw probleem',
      placeholder: 'Is er een probleem?',
      descriptionTooLong: 'Uw probleem is te lang',
      askCreateIssue: 'Wilt u een probleem melden?',
      newIssueCreated: 'Probleem gecreëerd',
      askCloseLoan: 'Wilt u uw lening afsluiten met de status "Succesvol afgerond"?',
      closedLoanSuccess: 'Lening succesvol afgesloten',
      tagMarkedIssues: 'Markeer alle problemen die u had',
      buttonProceed: 'Ga door met het evalueren van het probleem',
      noIssueSelected: 'Er is geen probleem geselecteerd',
      askProceedIssue: 'Wilt u doorgaan met uw probleem?',
    },
    rating: {
      yourRatingLabel: 'Uw beoordeling',
      yourFeedbackLabel: 'Uw feedback',
      sendFeedback: 'Feedback verzenden',
      textPlaceHolder: 'Uw feedback hier',
      chooseStarMessage:'Selecteer een ster voor beoordeling',
      editorMessage: 'Voeg alstublieft wat feedback toe',
      afterSaveMessage: 'Uw feedback is toegevoegd',
      starLabel: '%% rating',   /* User:lender or borrower rating */
      userLabel: '%% feedback', /* User:lender or borrower feedback */
    },
    statusLabel: {
      1: 'Aangevraagd',
      2: 'Geaccepteerd',
      3: 'Betaald',
      4: 'Overeengekomen ontmoeting',
      5: 'Uitgeleend',
      6: 'Overeengekomen terugkeer',
      7: 'Teruggekeerd',
      8: 'Afgerond',
      9: '--Gereserveerd--',
      10: 'Klaar met problemen',
      11: '--Gereserveerd--',
      12: 'Geannuleerd door Verhuurder',
      13: 'Geannuleerd door Huurder',
    },
    signImage: {
      title: 'Voeg uw handtekening toe om de acceptatie van de autolening te bevestigen',
      noSignMessage: 'Er is geen bericht geschreven, voeg er een toe',
    },
  },
  admin: {
    title: 'Beheerderspaneel',
    sections: {
      carPricing: 'Slimme prijzen',
      carPricingEdit: 'Prijs Editie',
      carLoanGrid: 'Huidige openstaande leningen',
      buyoutDeposit: {
        adminButton: 'Buyout-aanbetalingen',
        panelTitle: 'Opties voor buy-outstortingen',
        editTitle: 'Buyout Deposit Editie',
        feeLabel: 'Uitkoopsom aanbetalingskosten',
        toPayLabel: 'Aanbetaling voor afkoopsom',
        displayMessageLabel: 'Bericht om weer te geven bij selectie',
        showOptionLabel: 'Optie weergeven op selectielijst',
        messageNoEdited: 'Deze optie kan niet worden bewerkt',
      },
      refund: {
        adminButton: 'Terugbetalingen',
        panelTitle: 'Auto is uitgeleend met problemen',
        loanTag: 'Lening Tag',
        edit:{
          tagLoan: 'Leengegevens / Startdatum / Einddatum',
          tagUsers: 'Uitlener / Lener',
          tagFuel: 'Brandstof bij begin / Brandstof bij retour',
          tagPlace: 'Plaats van levering / Plaats van retour',
          tagDate: 'Leverdatum / Retourdatum',
          tagOdometer: 'Kilometerteller bij begin / Kilometerteller bij terugkomst',
          tagIssueComment: 'Opmerkingen bij het probleem',
          tagIssueImages: 'Probleemafbeeldingen',
          tagMarkedIssues: 'Alle problemen die de gebruiker had',
          tagCancelIssue: 'Wilt u deze terugbetaling annuleren?',
          tagCancelMessage: 'Dit probleem is geannuleerd',
          tagAcceptIssue: 'Wilt u doorgaan met de terugbetaling?',
          tagAcceptMessage: 'Dit probleem is goedgekeurd voor terugbetaling, ga verder zoals u wilt',
        },
      },
    },
  },
  googleMap: {
    dialog: {
      title: 'Zoekopdracht',
      inputTitle: 'Zoek naar een locatie',
      inputPlaceHolder: 'Voer een locatie in ...',
    },
  },
  document: {
    borrowerDetails: 'Deel I: Gegevens van lener/bestuurder',
    extraDriverDetails: 'Optioneel: Extra bestuurdersgegevens',
    lenderDetails: 'Deel II: Gegevens van de geldverstrekker',
    rentailPeriodDetails: 'Leenperiode Details',
    carDetails: 'Autogegevens',
    allowedProhibitedActions: 'Toegestane en verboden handelingen',
    contractSigning: 'Contractondertekening',
    partBorrower: 'Deel I: Lener',
    partLender: 'Deel II: Geldschieter',
    pickUpTime: 'Ophaaltijd',
    returnTime: 'Terugkeertijd',
    locationPickReturn: 'Ophaal- en retourlocatie',
  },
};

export default dictionaryNL;
